import styled from "@emotion/styled";
import type { ReactNode } from "react";

import { FullSizeContainer } from "../layout/FullSizeContainer";

const ActivityPageLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(auto, 1024px);

  justify-content: center;

  height: 100%;
  padding: 50px;
`;

export const ActivityContainer = styled.div<{ selected?: boolean }>`
  width: 100%;
  height: 100%;
  box-shadow: ${({ theme }) => theme.boxShadow.selected};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.surface};
  overflow: hidden;
`;

type Props = {
  children: ReactNode;
};

/**
 * @deprecated This is only used for legacy activity types, and should be removed.
 */
export const ActivityPageContainer = ({ children }: Props) => {
  return (
    <FullSizeContainer>
      <ActivityPageLayout>
        <ActivityContainer selected={true} data-test="activity-container">
          {children}
        </ActivityContainer>
      </ActivityPageLayout>
    </FullSizeContainer>
  );
};
